import { globalKeys } from 'assets/data/global-keys';

export default function useDownloadApp() {
  const { $storageService } = useServices();

  const downloadLink = computed(() => {
    const btag = $storageService.getCookie({
      key: globalKeys.marketingKeys.bannerTag,
    });
    return `https://info.jpc.africa/api/v1/JackpotCityAppDownload/?btag=${
      !!btag ? btag : 'P97425-PR26622-CM89032-TS1984022'
    }`;
  });

  function downloadApp() {
    window.open(downloadLink.value);
  }

  return {
    downloadLink,
    downloadApp,
  };
}
